module.exports = __webpack_public_path__ + "media/images/favicon/favicon-32x32-fbe7460943c2a92beeb97ad0d182fef3.png";